/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Invite_Codes_Create_ButtonInputs */

const en_admin_invite_codes_create_button = /** @type {(inputs: Admin_Invite_Codes_Create_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Invite Code`)
};

const zh_admin_invite_codes_create_button = /** @type {(inputs: Admin_Invite_Codes_Create_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新建邀请码`)
};

/**
* | output |
* | --- |
* | "New Invite Code" |
*
* @param {Admin_Invite_Codes_Create_ButtonInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_invite_codes_create_button = /** @type {((inputs?: Admin_Invite_Codes_Create_ButtonInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Invite_Codes_Create_ButtonInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_invite_codes_create_button(inputs)
	return zh_admin_invite_codes_create_button(inputs)
});
export { admin_invite_codes_create_button as "admin.invite_codes.create_button" }